module.exports = __webpack_public_path__ + "media/images/talent/feature-05-d2868cc33b21dc1fe8099d1db4efeede.svg";